import { NavItem } from '@/interfaces';
import { Component, Mixins } from 'vue-property-decorator';
import PrivilegeMixin from './PrivilegeMixin';
import { navItems } from './NavItems';



@Component
export default class NavBarMixin extends Mixins(PrivilegeMixin) {
  public checkItemAccess(item: NavItem): boolean {
    // console.log('checkItemAccess()', item);
    if (item.privilege) {
      return this.roleCheckNavBar(item.privilege);
    } else {
      return false;
    }
  }

  public checkItemsAccess(items: NavItem[]) {
    const result: NavItem[] = [];
    for (const navItem of items) {
      if (navItem.menuItems) {
          const newItems = this.checkItemsAccess(navItem.menuItems);
          if (newItems.length) {
            const newItem: NavItem = {...navItem};
            newItem.menuItems = newItems;
            result.push(newItem);
          }
      } else {
        if (this.checkItemAccess(navItem)) {
          result.push(navItem);
        }
      }
    }
    return result;
  }

  public get navItems() {
    return this.checkItemsAccess(navItems);
  }
}
